export const contactsData = {
  email: "m.tonsy97@gmail.com",
  phone: "+201121145897-+201067741297",
  address: "6th-octobar, Maadi, Fasil, Cairo-Giza-Egypt - 11371 ",
  sheetAPI: "",
};